import React from 'react'

const React_Coding_Practice_38 = () => {
  return (
    <div>
      <h1>Coding Pratice 38</h1>
    </div>
  )
}

export default React_Coding_Practice_38
